import { Progress } from "@material-tailwind/react";

export function ProgressLabel() {
  return <Progress value={50} label="Completed" />;
}
